export const getCurrentSubMenuOpenId = state => state.menuContent.currentSubMenuOpenId
export const selectText = state => state.menuContent.text;
